import { Section } from "../../styles/reusables";
import styled from "styled-components";
import { v, b } from "../../styles/variables";

export const HomeSection = styled(Section)`
	> div {
		flex: 1;
	}

	.brief-info {
		display: flex;
		flex-direction: column;
		gap: ${v.mediumDist};

		button {
			width: 70%;

			@media ${b.medium} {
				width: 50%;
			}
			@media ${b.large} {
				width: 30%;
			}
		}
	}

	.image {
		position: relative;

		.overlay {
			position: absolute;
			background: ${({ theme }) => theme.primary2};
			opacity: 0.3;
			width: 100%;
			height: 90%;
			top: 10%;
			z-index: -1;
			border-radius: 35% 70% 35% 70%;
		}
	}
`;
